import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Password tidak sama"); return; }
    if (!token) { toast.error("Token tidak ada"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password berhasil diubah");
      navigate("/login");
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-[calc(100vh-5rem)] lumina-bg-soft flex items-center justify-center py-16" data-testid="reset-page">
      <div className="lumina-card w-full max-w-md p-10">
        <div className="lumina-label mb-2">Reset</div>
        <h1 className="font-serif text-4xl text-[#1A1728] mb-6">Password Baru</h1>
        <form onSubmit={submit} className="space-y-4">
          <input required type="password" minLength={6} placeholder="Password baru (min. 6 karakter)" value={password} onChange={e=>setPassword(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] outline-none" data-testid="reset-password" />
          <input required type="password" minLength={6} placeholder="Konfirmasi password" value={confirm} onChange={e=>setConfirm(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] outline-none" data-testid="reset-confirm" />
          <button disabled={loading} className="lumina-btn-primary w-full" data-testid="reset-submit">{loading ? "Memproses…" : "Ganti Password"}</button>
        </form>
        <p className="text-sm text-[#5C5870] mt-6 text-center"><Link to="/login" className="text-[#6B4BA3] font-medium">Kembali ke login</Link></p>
      </div>
    </div>
  );
}
